function normalize(name) {
  return String(name || '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function tokenize(name) {
  return normalize(name).split(/\s+/).filter(Boolean);
}

function levenshtein(a, b) {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  const dp = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = dp[0];
    dp[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = dp[j];
      dp[j] = a[i - 1] === b[j - 1]
        ? prev
        : 1 + Math.min(prev, dp[j - 1], dp[j]);
      prev = tmp;
    }
  }
  return dp[b.length];
}

function tokenJaccard(aTokens, bTokens) {
  if (aTokens.length === 0 && bTokens.length === 0) return 0;
  const a = new Set(aTokens);
  const b = new Set(bTokens);
  let inter = 0;
  for (const t of a) if (b.has(t)) inter += 1;
  return inter / (a.size + b.size - inter);
}

export function nameSimilarity(a, b) {
  const na = normalize(a);
  const nb = normalize(b);
  if (!na && !nb) return 0;
  if (na === nb) return 1;

  const ta = tokenize(a);
  const tb = tokenize(b);
  const [shortT, longT] = ta.length <= tb.length ? [ta, tb] : [tb, ta];

  if (shortT.length > 0 && shortT.every((t) => longT.includes(t))) {
    return 0.85 + 0.15 * (shortT.length / longT.length);
  }

  const jaccard = tokenJaccard(ta, tb);
  const maxLen = Math.max(na.length, nb.length);
  const lev = maxLen === 0 ? 0 : 1 - levenshtein(na, nb) / maxLen;

  if (na.includes(nb) || nb.includes(na)) {
    return Math.min(1, Math.max(jaccard, lev) + 0.2);
  }

  return 0.5 * jaccard + 0.5 * lev;
}
